export const ORGANIZATION_ARCHIVE = 'ORGANIZATION_ARCHIVE';
export const WORKSPACE_ARCHIVE = 'WORKSPACE_ARCHIVE';
export const ORGANIZATION_NAME = 'ORGANIZATION_NAME';